import React from 'react';
import PropTypes from 'prop-types';
import useTabStripRegistration from 'hooks/useTabStripRegistration';
import PackageTabCTab from './PackageTabCTab/PackageTabCTab';

const PackageTabC = (props) => {
  const {
    packageTabs,
    identifier,
    ...restPackageTabC
  } = props;

  const {
    items = [],
    ...restPackageTabs
  } = packageTabs;

  const {
    registrationError,
  } = useTabStripRegistration({ identifier, className: '.k-tab-strip' });

  return (
    registrationError || (items.length > 0 &&
      <div id={`TabStrip-${`${identifier ? `${identifier}-` : ''}select`}`}>
        {items.map((item, i) => (
          <PackageTabCTab
            key={`package-tab-${i}`}
            index={i}
            {...restPackageTabs}
            {...item}
            {...restPackageTabC}
          />
        ))}
      </div>)
  );
};

PackageTabC.propTypes = {
  /**
   * A list of packageTab Objects
  */
  packageTabs: PropTypes.shape({
    items: PropTypes.array,
  }),
  /**
   * A unique identifer for the component
  */
  identifier: PropTypes.string,
};

export default PackageTabC;
